'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["views", "onViewChange", "view", "className"];
import * as React from 'react';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import ExpandMoreOutlined from '@mui/icons-material/ExpandMoreOutlined';
import { useMergedRefs } from '@base-ui/utils/useMergedRefs';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useEventCalendarStyledContext } from "../../EventCalendarStyledContext.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ViewSwitcherRoot = styled('div', {
  name: 'MuiEventCalendar',
  slot: 'ViewSwitcher'
})({
  display: 'flex'
});
export const ViewSwitcher = /*#__PURE__*/React.forwardRef(function ViewSwitcher(props, forwardedRef) {
  const {
      views,
      onViewChange,
      view,
      className
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const containerRef = React.useRef(null);
  const handleRef = useMergedRefs(forwardedRef, containerRef);
  const {
    classes,
    localeText
  } = useEventCalendarStyledContext();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleMenuItemClick = (event, newView) => {
    onViewChange(newView, event.nativeEvent);
    handleMenuClose();
  };
  return /*#__PURE__*/_jsxs(ViewSwitcherRoot, _extends({
    ref: handleRef
  }, other, {
    className: clsx(className, classes.viewSwitcher),
    children: [/*#__PURE__*/_jsx(Button, {
      className: classes.viewSwitcherButton,
      size: "medium",
      id: "view-switcher-button",
      "aria-controls": open ? 'view-switcher-menu' : undefined,
      "aria-haspopup": "true",
      "aria-expanded": open ? 'true' : undefined,
      "aria-label": "Switch View",
      onClick: handleMenuOpen,
      endIcon: /*#__PURE__*/_jsx(ExpandMoreOutlined, {}),
      children: localeText[view]
    }), /*#__PURE__*/_jsx(Menu, {
      className: classes.viewSwitcherMenu,
      id: "view-switcher-menu",
      anchorEl: anchorEl,
      open: open,
      onClose: handleMenuClose,
      slotProps: {
        list: {
          'aria-labelledby': 'view-switcher-button',
          role: 'listbox'
        }
      },
      children: views.map(viewItem => /*#__PURE__*/_jsx(MenuItem, {
        selected: view === viewItem,
        "aria-selected": view === viewItem,
        onClick: event => handleMenuItemClick(event, viewItem),
        children: localeText[viewItem]
      }, viewItem))
    })]
  }));
});
if (process.env.NODE_ENV !== "production") ViewSwitcher.displayName = "ViewSwitcher";